export const lastBookingFilter = [
  { title: 'Car Park Code', value: 'carParkCode' },
  { title: 'Phone', value: 'phone' },
  { title: 'Registration Mark', value: 'registrationMark' },
];

export const defaultDetails = {
  car: { value: '', label: '' },
  changeType: { value: '', label: '' },
  validFrom: '',
  validTo: '',
  bookingValidTo: '',
};

export const changeTypeOptions = [
  { value: 'temporary', label: 'Temporary' },
  { value: 'permanent', label: 'Permanent' },
];

export const defaultLPNChangeable = {
  hourlyVehiclePresent: false,
  isPermanentChangeable: false,
  isTempChangeable: false,
  monthlyVehiclePresent: false,
  permanentChanged: false,
  tempChanged: false,
  vehicleIsPresent: false,
};
